import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import pure from "recompose/pure";
import FalseIcon from "material-ui/svg-icons/content/clear";
import TrueIcon from "material-ui/svg-icons/action/done";

export const BooleanField = ({source, record = {}, elStyle, defaultValue, label}) => {
  
  const value2 = get(record, source) === "" ? defaultValue : get(record, source)
  
  return <div style={{"display": 'flex', "flexDirection": 'row'}}>
          <span style={{flex:2}}>{label}</span>
          {value2 ? <TrueIcon style={{flex:1}} /> : <FalseIcon style={{flex:1}}/>}
        </div>  
  
};

BooleanField.propTypes = {
  addLabel: PropTypes.bool,
  elStyle: PropTypes.object,
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired
};

const PureBooleanField = pure(BooleanField);

PureBooleanField.defaultProps = {
  addLabel: false,
  elStyle: {
    display: "block",
    margin: "auto"
  }
};

export default PureBooleanField;



// WEBPACK FOOTER //
// ./src/components/CRM/BooleanField.js